import React from 'react'
import Heading from '../../../common/Heading'
import RecentCard from './RecentCard'
import './recent.css'

const Recent = () => {
  return (
    <div>
      <div className="recent padding">
        <div className="container">
          <Heading title='Recent Property Listed' subtitle='lorem lorem this is the best ever for every one what are you waiting for be quicker '/>
          <RecentCard/>
        </div>
      </div>
    </div>
  )
}

export default Recent
